/* Knowledge categories */
export const GET_COURSES = "GET_COURSES"
export const GET_COURSES_SUCCESS = "GET_COURSES_SUCCESS"
export const GET_COURSES_BY_USER = "GET_COURSES_BY_USER"
export const GET_COURSES_BY_USER_SUCCESS = "GET_COURSES_BY_USER_SUCCESS"
export const API_ERROR = "API_ERROR"
